import React from "react";
import "../../App.css";
import "./FormElement.css";
import FormInput from "../FormInput/FormInput";
import Tooltip from "../Tooltip/Tooltip";
import { formatClassNames } from "../../helpers/util";


function FormElement({
  label,
  id,
  unit,
  tooltip,
  register,
  errors,
  value,
  transparent,
  inputs,
  style,
}) {
  return (
    <div
      style={style}
      className={formatClassNames(
        "form-element-wrapper", {
          disabled: value || register == null,
          transparent, inputs, fullWidth: !label
      })}
    >
      <main>
        {label && (
          <label htmlFor={id}>
            {label}{" "}
            {inputs
              ? inputs.map(
                  (input) =>
                    input.errors && (
                      <span className="error">
                        <Tooltip
                          icon="fa-exclamation"
                          style={{ marginLeft: "0" }}
                          content={input.errors.message}
                        />
                      </span>
                    )
                )
              : errors && (
                  <span className="error">
                    <Tooltip
                      icon="fa-exclamation"
                      style={{ marginLeft: "0" }}
                      content={errors.message}
                    />
                  </span>
                )}
          </label>
        )}

        {!inputs ? (
          <FormInput
            fullWidth={!label}
            value={value}
            unit={unit}
            register={register}
            id={id}
            tooltip={tooltip}
          />
        ) : (
          <div className="inputs">
            {inputs.map((input, index) => (
              <FormInput
                key={index}
                value={input.value}
                unit={input.unit}
                register={input.register}
                id={input.id}
                tooltip={input.tooltip}
              />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

export default FormElement;
